import { render, staticRenderFns } from "./CustomerActivities.vue?vue&type=template&id=04a0e01a&scoped=true"
import script from "./CustomerActivities.vue?vue&type=script&lang=js"
export * from "./CustomerActivities.vue?vue&type=script&lang=js"
import style0 from "./CustomerActivities.vue?vue&type=style&index=0&id=04a0e01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0e01a",
  null
  
)

export default component.exports